<template>
    <DnsProviderForm
        :dns-provider="dnsProvider"
        :api-types="apiTypes"
        :errors="errors"
        :only-show-form="true"
    />
    <DFabs>
        <DFab
            id="btn-edit"
            icon="pencil"
            :label="__('messages.actions.edit')"
            @click="$inertia.get($route('settings.dns-providers.edit', dnsProvider.id))"
        />
    </DFabs>
</template>

<script setup>
import DnsProviderForm from '~@/Components/Settings/DNSProvider/Form'

defineProps({
    dnsProvider: {
        type: Object,
        default () {
            return {}
        }
    },
    apiTypes: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})
</script>

<style scoped lang="scss">

</style>
